module.exports = __webpack_public_path__ + "media/images/undraw/shift/export_files-58d3400ecfe850c0601481d45574b302.png";